export default __webpack_public_path__ + "static/media/a1.b7835417.png";